export type AdoptionStatus = "available" | "pending" | "unavailable";

export type ChangedAdoptionStatus = Exclude<AdoptionStatus, "available">;

const ADOPTION_STATUSES: readonly AdoptionStatus[] = [
    "available",
    "pending",
    "unavailable",
];

export function toAdoptionStatus(
    raw: string | null | undefined,
): AdoptionStatus {
    return ADOPTION_STATUSES.includes(raw as AdoptionStatus)
        ? (raw as AdoptionStatus)
        : "available";
}

export function changedAdoptionStatus(
    status: AdoptionStatus | undefined,
): ChangedAdoptionStatus | null {
    return status === "pending" || status === "unavailable" ? status : null;
}

export const ADOPTION_STATUS_LABEL: Record<ChangedAdoptionStatus, string> = {
    pending: "Adoption pending",
    unavailable: "Found a home",
};
